<script setup>
import { computed } from 'vue';
import { useCompetitorAppConfig } from 'src/composables/useCompetitorAppConfig';

const props = defineProps({
  rows: {
    type: Array,
    required: true,
  },
  applicationType: {
    type: String,
    required: true
  }
});

const { getApplicationType } = useCompetitorAppConfig();

const applicationTypeConfig = computed(() => getApplicationType(props.applicationType));
</script>

<template>
  <div class="ce-technicalPropertyTableValue">
    <div class="title">
      {{ applicationTypeConfig.title }}
    </div>

    <div>
      <table>
        <tr
          v-for="(row, rowIndex) in rows"
          :key="rowIndex">
          <component
            v-for="(value, colIndex) in row.columns"
            :is="row.isHeader ? 'th' : 'td'"
            :key="`${rowIndex}-${colIndex}`">
            {{ value ?? '-' }}
          </component>
        </tr>
      </table>
    </div>
  </div>
</template>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-technicalPropertyTableValue {
  overflow-x: auto;
  width: 100%;

  .title {
    margin-bottom: @space-1;
  }

  table {
    border-spacing: 2px;
    width: 100%;

    th, td {
      padding: @space-1 @space-3;
      text-align: center;
    }

    tr {
      &:nth-child(odd) {
        background: @color-mono-80;
      }
    }
  }
}
</style>
